import { OrderType } from 'types';

export const CONFIRM_BDO_CARD_COMMAND_TYPE = 'ConfirmBdoCard';

export interface ConfirmBdoCardCommand {
	orderId: number;
	orderType: OrderType;
}
